import React from 'react';

interface InfoCardProps {
  title: string;
  items: { label: string; value: React.ReactNode }[];
}

const InfoCard: React.FC<InfoCardProps> = ({ title, items }) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6 h-full flex flex-col">
      <h3 className="text-base font-semibold text-foreground mb-4">{title}</h3>
      <div className="divide-y divide-border flex-grow">
        {items.map((item, index) => {
          // Special handling for JSE yield table - stack vertically
          const isYieldTable = item.label === 'Target net ann\'l yield' && 
            typeof item.value === 'object' && 
            React.isValidElement(item.value) && 
            item.value.props?.className?.includes('mt-3');
          
          if (isYieldTable) {
            return (
              <div key={index} className="py-3 first:pt-0 last:pb-0">
                <div className="mb-3">
                  <span className="text-muted-foreground text-sm">{item.label}</span>
                </div>
                <div className="w-full">
                  {item.value}
                </div>
              </div>
            );
          }
          
          // Default side-by-side layout
          return (
            <div key={index} className="flex justify-between items-start py-3 first:pt-0 last:pb-0">
              <span className="text-muted-foreground text-sm">{item.label}</span>
              <div className="text-foreground font-medium text-right text-sm">{item.value}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InfoCard;
